if (window.ConstantsManager && !!ConstantsManager.CASETAGRAM_BASE_DOMAIN_CDN) {
  __webpack_public_path__ = `https://${ConstantsManager.CASETAGRAM_BASE_DOMAIN_CDN}/js/_vue/cms/dist/`
}


// WEBPACK FOOTER //
// ./src/publicpath.js